import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import SyncLog, { SyncLogTypes } from "models/sync-log"

export interface SyncLogSliceState {
  syncLogs: Partial<Record<SyncLogTypes, SyncLog>>
}

export const initialState: SyncLogSliceState = {
  syncLogs: {},
}

const syncLogSlice = createSlice({
  name: "syncLog",
  initialState,
  reducers: {
    setSyncLog(state, { payload }: PayloadAction<{ moduleName: SyncLogTypes, data: SyncLog }>) {
      state.syncLogs[payload.moduleName] = payload.data
    },
    clearSyncLogs(state) {
      state.syncLogs = {}
    },
  },
})

export const {
  setSyncLog,
  clearSyncLogs,
} = syncLogSlice.actions

export default syncLogSlice.reducer